/* eslint-disable react/require-default-props, react/no-unused-prop-types */
import BiddingFile from 'components/atoms/bidding_file';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import ReCAPTCHA from 'react-google-recaptcha';
import SolicitationEditalButton from 'components/atoms/solicitation_edital_button';

interface BiddingFileTypes {
  url: string;
  filename: string;
}

interface BiddingAttachmentListProps {
  biddingStatusEdital: number;
  biddingFiles?: BiddingFileTypes[];
  requestEdital?: boolean;
  setRequestEdital?: React.Dispatch<React.SetStateAction<boolean>>;
  solicited?: boolean;
  situation?: string;
  biddingValidade?: string | null;
  omitSolicitation?: boolean;
}

const BiddingAttachmentList: React.FC<BiddingAttachmentListProps> = ({
  biddingFiles = [],
  setRequestEdital = () => {},
  requestEdital = false,
  solicited = false,
  situation,
  biddingValidade,
  omitSolicitation = false,
}) => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(null);

  const recaptchaRef = React.createRef<ReCAPTCHA>();

  const hiddenSituations = [
    'ADIADA',
    'ADIADA SINE DIE',
    'ANULADA',
    'CANCELADA',
    'REVOGADA',
    'SUSPENSA',
    'SUSPENSA SINE DIE',
  ];

  const shouldHideButton = hiddenSituations.includes(situation || '');
  const isBiddingExpired = biddingValidade ? new Date(biddingValidade) < new Date() : false;

  return (
    <div>
      {!omitSolicitation &&
        !shouldHideButton &&
        !isBiddingExpired &&
        !biddingFiles?.length &&
        (profile?.alfa_tester || profile.clientId % 10 === 0 ? (
          <SolicitationEditalButton
            setRequestEdital={setRequestEdital}
            requestEdital={requestEdital}
            solicited={solicited}
          />
        ) : (
          <i className="btn btn-sm pl-0">Nenhum edital disponível.</i>
        ))}

      {profile.enable_captcha && showCaptcha === true && biddingFiles?.length > 0 && (
        <div className="w-100 my-2">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Lcex2sdAAAAAKMks7alzUBCyRFy88kgqM07DcwW"
            onChange={(recaptchaToken: React.SetStateAction<string | null>) => {
              setShowCaptcha(false);
              setToken(recaptchaToken);
            }}
            hl="pt-BR"
          />
        </div>
      )}

      {profile.enable_captcha && biddingFiles?.length > 0 && token === null && (
        <button
          type="button"
          className="btn btn-success btn-sm mr-1 mb-1"
          onClick={() => {
            setShowCaptcha(!showCaptcha);
          }}
          disabled={showCaptcha}
        >
          Visualizar Edital
        </button>
      )}

      {biddingFiles?.length > 0 &&
        (!profile.enable_captcha || token !== null) &&
        biddingFiles?.map((file) => (
          <BiddingFile
            key={`my_bidding_item_file_${file.url}`}
            filename="Baixar Edital"
            url={file.url}
          />
        ))}
    </div>
  );
};

export default BiddingAttachmentList;
